export function entitledIncidentWorkflows(entitlementSummary) {
  if (!entitlementSummary) return [];

  const configured = Array.isArray(entitlementSummary.workflows)
    ? entitlementSummary.workflows
    : entitlementSummary.workflow
      ? [entitlementSummary.workflow]
      : [];

  // Active workspaces return license summaries with a nested workflow.
  // Trial summaries and older responses contain the workflow directly.
  return configured
    .filter((entry) => entry?.can_process !== false && !entry?.processing_on_hold)
    .map((entry) => entry?.workflow || entry)
    .filter((workflow) => workflow?.key)
    .map((workflow) => ({
      key: workflow.key,
      label: workflow.label || workflow.key,
      value: workflow.label || workflow.key,
    }));
}


const EVIDENCE_CATEGORIES_BY_WORKFLOW = {
  quality_incident_ncr: [
    "Visual defect or damage",
    "Inspection result",
    "Material or part label",
    "Lot, batch, or heat-number tag",
    "Supplier documentation",
    "Packaging or shipping condition",
    "Production or process evidence",
    "Other",
  ],
};


export function evidenceCategoriesForWorkflows(workflows) {
  const categories = (workflows || []).flatMap(
    (workflow) => EVIDENCE_CATEGORIES_BY_WORKFLOW[workflow.key] || []
  );
  return [...new Set(categories)];
}
